/* ------------------------------------------------------------
   nv-pdp.js
   商品ページ改修 / Product page redesign

   価格まわり / Price area
   - セールのカウントダウンを価格の上へ、割引率・通常価格・お得額
     Sale countdown above the price; discount, regular price, savings
   - 要点カード（状態・サイズ・付属品） / Key facts card
   - 画像右上のランク、商品コードのコピー
     Rank badge on the image; copy button for the item code
   ボタンまわり / Buttons
   - お気に入り（Growave）を文字リンクにし、クリックはアプリへ渡す
     Wishlist (Growave) shown as a text link; clicks go to the app
   - スマホでスクロールした時の固定カートボタン
     Sticky add-to-cart bar on mobile
   説明文 / Description
   - WASABI SWITCH の .lx-sec を読み直し、PC は3列＋カード、
     スマホは折りたたみで表示する
     The WASABI SWITCH .lx-sec blocks are re-laid out: three columns
     plus cards on desktop, an accordion on mobile

   見出しの文言では判定せず、class と構造で判定する（多言語で変わるため）。
   custom.js がタブを組み終わってから動く。
   Elements are found by class and structure, never by heading text,
   because the text is translated. Runs after custom.js built the tabs.
   ------------------------------------------------------------ */
(function () {
  'use strict';

  var L = {
    ja: {
      cond: '状態', size: 'サイズ', acc: '付属品', none: 'なし（本体のみ）', rank: 'ランク',
      copy: 'コピー', copied: 'コピーしました', sep: '：', join: '／',
      tax: '税込', was: '通常価格', save: '（{x}お得）',
      fav: 'お気に入り', inquiry: 'お問い合わせフォーム',
      info: '商品情報', condition: 'コンディション', thisItem: 'この商品', state: 'この商品の状態',
      width: '幅', height: '高さ', handle: '持ち手', depth: 'マチ（奥行）',
      accN: '（{n}点）', accCount: '{n}点', notes: 'ご購入前の注意事項',
      payShip: 'お支払い・配送・返品', payMethods: 'お支払い方法', ship: '配送',
      shipText: '国内送料無料・1〜5営業日以内に発送', returns: '返品・交換について', warranty: '保証について',
      cod: '※代金引換は日本国内へのお届けのみご利用いただけます。',
      loanNote: '分割払いもご利用いただけます', loanCalc: '月々の目安を計算',
      cdHead: 'セール終了まで', cdDay: '日'
    },
    en: {
      cond: 'Condition', size: 'Size', acc: 'Accessories', none: 'None (item only)', rank: 'Grade',
      copy: 'Copy', copied: 'Copied', sep: ': ', join: ' / ',
      tax: 'tax incl.', was: 'Regular price', save: '(Save {x})',
      fav: 'Wishlist', inquiry: 'Contact form',
      info: 'Product information', condition: 'Condition', thisItem: 'This item', state: 'Condition details',
      width: 'W', height: 'H', handle: 'Handle', depth: 'Depth',
      accN: ' ({n})', accCount: '{n}', notes: 'Before you buy',
      payShip: 'Payment, shipping & returns', payMethods: 'Payment methods', ship: 'Shipping',
      shipText: '', loanNote: '', loanCalc: '', returns: 'Returns & exchanges', warranty: 'Warranty',
      cdHead: 'Sale ends in', cdDay: 'd'
    },
    fr: {
      cond: 'État', size: 'Taille', acc: 'Accessoires', none: 'Aucun (article seul)', rank: 'Grade',
      copy: 'Copier', copied: 'Copié', sep: ' : ', join: ' / ',
      tax: 'TTC', was: 'Prix habituel', save: '(Économisez {x})',
      fav: 'Favoris', inquiry: 'Formulaire de contact',
      info: 'Informations produit', condition: 'État', thisItem: 'Cet article', state: 'Détails de l’état',
      width: 'L', height: 'H', handle: 'Anse', depth: 'Profondeur',
      accN: ' ({n})', accCount: '{n}', notes: 'Avant l’achat',
      payShip: 'Paiement, livraison et retours', payMethods: 'Moyens de paiement', ship: 'Livraison',
      shipText: '', loanNote: '', loanCalc: '', returns: 'Retours et échanges', warranty: 'Garantie',
      cdHead: 'Fin de la promotion dans', cdDay: ' j'
    },
    es: {
      cond: 'Estado', size: 'Tamaño', acc: 'Accesorios', none: 'Ninguno (solo el artículo)', rank: 'Grado',
      copy: 'Copiar', copied: 'Copiado', sep: ': ', join: ' / ',
      tax: 'IVA incl.', was: 'Precio habitual', save: '(Ahorra {x})',
      fav: 'Favoritos', inquiry: 'Formulario de contacto',
      info: 'Información del producto', condition: 'Estado', thisItem: 'Este artículo', state: 'Detalles del estado',
      width: 'An', height: 'Al', handle: 'Asa', depth: 'Fondo',
      accN: ' ({n})', accCount: '{n}', notes: 'Antes de comprar',
      payShip: 'Pago, envío y devoluciones', payMethods: 'Formas de pago', ship: 'Envío',
      shipText: '', loanNote: '', loanCalc: '', returns: 'Devoluciones y cambios', warranty: 'Garantía',
      cdHead: 'La oferta termina en', cdDay: ' d'
    },
    ko: {
      cond: '상태', size: '사이즈', acc: '부속품', none: '없음 (본품만)', rank: '등급',
      copy: '복사', copied: '복사됨', sep: ': ', join: ' / ',
      tax: '세금 포함', was: '정상가', save: '({x} 할인)',
      fav: '관심 상품', inquiry: '문의 양식',
      info: '상품 정보', condition: '컨디션', thisItem: '이 상품', state: '상태 상세',
      width: '가로', height: '세로', handle: '손잡이', depth: '폭',
      accN: ' ({n}점)', accCount: '{n}점', notes: '구매 전 안내',
      payShip: '결제·배송·반품', payMethods: '결제 방법', ship: '배송',
      shipText: '', loanNote: '', loanCalc: '', returns: '반품·교환 안내', warranty: '보증 안내',
      cdHead: '세일 종료까지', cdDay: '일'
    },
    zh: {
      cond: '品相', size: '尺寸', acc: '附属品', none: '无（仅商品本身）', rank: '等级',
      copy: '复制', copied: '已复制', sep: '：', join: '／',
      tax: '含税', was: '原价', save: '（节省 {x}）',
      fav: '收藏', inquiry: '咨询表单',
      info: '商品信息', condition: '品相', thisItem: '本商品', state: '品相详情',
      width: '宽', height: '高', handle: '提手', depth: '侧宽',
      accN: '（{n}件）', accCount: '{n}件', notes: '购买前须知',
      payShip: '支付·配送·退货', payMethods: '支付方式', ship: '配送',
      shipText: '', loanNote: '', loanCalc: '', returns: '退换货说明', warranty: '保修说明',
      cdHead: '促销结束还剩', cdDay: '天'
    }
  };

  // ランクの色（商品一覧のランク表記と同じ） / Grade colours, same as the collection grid
  var RANK_COLOR = {
    'N': '#1B5340', 'S': '#2A6E52', 'SA': '#3C8461',
    'A+': '#2B5680', 'A': '#3E6C96', 'A-': '#5A82AC',
    'B+': '#7E6029', 'B': '#96793C', 'B-': '#A88F52', 'C': '#6E6A65'
  };
  var NONE_WORDS = ['なし', '無し', '-', 'ー', 'none', 'aucun', 'aucune', 'ninguno', 'ninguna', '없음', '无', '無'];
  var SIZE_SKIP = ['サイズ備考'];
  var DESK = '(min-width: 1008px)';

  var code = (document.documentElement.lang || 'ja').split('-')[0].toLowerCase();
  var t = L[code] || L.ja;

  /* ---------- 共通 / Helpers ---------- */
  function txt(node) {
    return node ? (node.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }
  function firstLine(node) {
    var d = document.createElement('div');
    d.innerHTML = (node.innerHTML || '').split(/<br\s*\/?>/i)[0];
    return txt(d);
  }
  function make(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) { e.className = cls; }
    if (text != null) { e.textContent = text; }
    return e;
  }
  function fill(s, x) { return String(s).replace('{x}', x).replace('{n}', x); }
  function rankKey(s) {
    return String(s).replace(/[−–—－]/g, '-').replace(/\s+/g, '');
  }
  function chip(grade, cls) {
    var c = make('span', 'nv-chip' + (cls ? ' ' + cls : ''), grade);
    var col = RANK_COLOR[rankKey(grade)];
    if (col) { c.style.setProperty('--nv-rank', col); }
    return c;
  }
  function svg(path, size) {
    var s = size || 18;
    return '<svg viewBox="0 0 24 24" width="' + s + '" height="' + s + '" fill="none" stroke="currentColor" ' +
      'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + path + '</svg>';
  }
  var ICON = {
    heart: '<path d="M12 20s-7.5-4.6-7.5-10.2A4.2 4.2 0 0 1 12 7.2a4.2 4.2 0 0 1 7.5 2.6C19.5 15.4 12 20 12 20z"/>',
    store: '<path d="M4 10v10h16V10"/><path d="M3 10l2-6h14l2 6H3z"/><path d="M10 20v-5h4v5"/>',
    card: '<rect x="3" y="5.5" width="18" height="13" rx="2"/><path d="M3 10h18"/>',
    copy: '<rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3"/>',
    chevron: '<path d="M6 9l6 6 6-6"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
    mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3.5 7l8.5 6 8.5-6"/>'
  };
  function productData() {
    try { return JSON.parse(document.querySelector('[data-product-json]').textContent); } catch (e) { return null; }
  }

  /* ============================================================
     価格まわり / Price area
     ============================================================ */
  function buildPrice() {
    var list = document.querySelector('.ProductMeta .ProductMeta__PriceList');
    if (!list || list.getAttribute('data-nv-price') === '1') { return; }
    list.setAttribute('data-nv-price', '1');
    var now = list.querySelector('.ProductMeta__Price');
    var cmp = list.querySelector('.Price--compareAt');
    if (now) { now.parentNode.insertBefore(make('span', 'nv-tax', t.tax), now.nextSibling); }

    var data = productData();
    var v = null;
    if (data && data.product) {
      var vs = data.product.variants || [];
      for (var i = 0; i < vs.length; i++) { if (vs[i].id === data.selected_variant_id) { v = vs[i]; } }
      v = v || vs[0];
    }
    if (!cmp || !v || !v.compare_at_price || v.compare_at_price <= v.price) { return; }

    var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
    if (pct >= 1) { list.appendChild(make('span', 'nv-off', pct + '%OFF')); }

    // 通常価格の行 / Regular price line
    var was = make('div', 'nv-was');
    was.appendChild(make('span', 'nv-was__lb', t.was + ' '));
    was.appendChild(cmp);
    // お得額は円表示の時だけ / Savings only while the price is shown in yen
    var a = txt(now), b = txt(cmp);
    if (/^[¥￥][\d,]+$/.test(a) && /^[¥￥][\d,]+$/.test(b)) {
      var diff = parseInt(b.replace(/\D/g, ''), 10) - parseInt(a.replace(/\D/g, ''), 10);
      if (diff > 0) { was.appendChild(make('span', 'nv-was__save', fill(t.save, '¥' + diff.toLocaleString('ja-JP')))); }
    }
    list.parentNode.insertBefore(was, list.nextSibling);
  }

  // 在庫表示を価格の下へ / Move the stock line under the price
  function moveStock() {
    var inv = document.querySelector('.ProductForm__Inventory');
    var anchor = document.querySelector('.ProductMeta .nv-was') || document.querySelector('.ProductMeta .ProductMeta__PriceList');
    if (!inv || !anchor || inv.classList.contains('nv-stock')) { return; }
    inv.classList.add('nv-stock');
    anchor.parentNode.insertBefore(inv, anchor.nextSibling);
  }

  /* ---------- セールのカウントダウン / Sale countdown ----------
     アプリ（Hextom）が読み込み後に差し込むため、出現を待って価格の上へ移す。
     見出しはアプリ既定の英語のときだけ置き換える。
     The app (Hextom) inserts it after load: wait for it and move it above
     the price. The heading is replaced only while it is the English default. */
  function moveCountdown(cd) {
    var list = document.querySelector('.ProductMeta .ProductMeta__PriceList');
    if (!cd || !list || cd.classList.contains('nv-cd')) { return; }
    var head = cd.querySelector('.hc_cd_heading');
    if (head && /^\s*sale ends in/i.test(head.textContent)) { head.textContent = t.cdHead; }
    var out = make('span', 'nv-cd__time');
    var timer = cd.querySelector('.hc_cd-timer');
    if (timer) { timer.parentNode.insertBefore(out, timer); }
    function tick() {
      var h = txt(cd.querySelector('.hc_cd_hours'));
      if (!h) { return; }
      var days = parseInt(txt(cd.querySelector('.hc_cd_days')), 10) || 0;
      out.textContent = (days ? days + t.cdDay + ' ' : '') + h + ':' +
        txt(cd.querySelector('.hc_cd_minutes')) + ':' + txt(cd.querySelector('.hc_cd_seconds'));
    }
    tick();
    setInterval(tick, 1000);
    cd.classList.add('nv-cd');
    list.parentNode.insertBefore(cd, list);
    clearAsideSoon();
  }
  function waitCountdown() {
    function found(cd) { setTimeout(function () { moveCountdown(cd); }, 300); }
    var cd = document.querySelector('.ProductForm .hc_cd');
    if (cd) { found(cd); return; }
    if (!('MutationObserver' in window)) { return; }
    var mo = new MutationObserver(function () {
      var el = document.querySelector('.ProductForm .hc_cd');
      if (el) { mo.disconnect(); found(el); }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  /* ---------- 要点カード / Key facts card ---------- */
  function factsRow(label, valueNode) {
    var row = make('div', 'nv-facts__row');
    row.appendChild(make('span', 'nv-facts__lb', label));
    valueNode.classList.add('nv-facts__vl');
    row.appendChild(valueNode);
    return row;
  }
  function findSizeRow(root) {
    var panel = root.querySelector('[data-nv-panel="size"]');
    if (!panel) { return null; }
    var secs = panel.querySelectorAll('.lx-sec');
    for (var i = 0; i < secs.length; i++) {
      if (secs[i].querySelector('.lx-parts')) { continue; }
      var rows = secs[i].querySelectorAll('.lx-row');
      for (var j = 0; j < rows.length; j++) {
        var lb = rows[j].querySelector('.lx-lb');
        var vl = rows[j].querySelector('.lx-vl');
        if (!lb || !vl || SIZE_SKIP.indexOf(txt(lb)) !== -1) { continue; }
        return { label: txt(lb), value: firstLine(vl) };
      }
      return null;
    }
    return null;
  }
  function accText(root) {
    var pp = root.querySelector('.lx-parts');
    if (!pp) { return null; }
    var a = txt(pp);
    return (!a || NONE_WORDS.indexOf(a.toLowerCase()) !== -1) ? '' : a;
  }
  function buildFacts(root) {
    var price = document.querySelector('.ProductMeta .ProductMeta__PriceList');
    if (!price || document.querySelector('.nv-facts')) { return; }
    var card = make('div', 'nv-facts');

    var active = root.querySelector('.lx-rnk tr.active');
    if (active) {
      var tds = active.querySelectorAll('td');
      var v = make('div');
      var line = make('div', 'nv-facts__rank');
      line.appendChild(chip(txt(tds[0]), 'nv-facts__chip'));
      line.appendChild(make('span', 'nv-facts__desc', tds[1] ? txt(tds[1]) : ''));
      v.appendChild(line);
      var parts = root.querySelectorAll('.lx-cond-box .lx-row');
      var bits = [];
      for (var i = 0; i < parts.length; i++) {
        var plb = parts[i].querySelector('.lx-lb');
        var pvl = parts[i].querySelector('.lx-vl');
        if (plb && pvl && txt(pvl)) { bits.push(txt(plb) + t.sep + txt(pvl)); }
      }
      if (bits.length) { v.appendChild(make('div', 'nv-facts__sub', bits.join(t.join))); }
      card.appendChild(factsRow(t.cond, v));
      var meta = document.querySelector('.ProductMeta');
      if (meta) { meta.classList.add('nv-has-facts'); }
    }

    var size = findSizeRow(root);
    if (size && size.value) {
      var val = size.value.replace(/\s*[（(][^（()）]*[）)]\s*$/, '');
      if (size.label.toLowerCase() !== t.size.toLowerCase() && size.label !== 'サイズ') { val = size.label + ' ' + val; }
      card.appendChild(factsRow(t.size, make('div', '', val)));
    }

    var acc = accText(root);
    if (acc !== null) { card.appendChild(factsRow(t.acc, make('div', '', acc || t.none))); }

    if (card.children.length) {
      var after = document.querySelector('.ProductMeta .nv-stock') || document.querySelector('.ProductMeta .nv-was') || price;
      after.parentNode.insertBefore(card, after.nextSibling);
    }
  }

  /* ---------- 分割払いの案内（価格の下に1行） / Instalment note under the price ----------
     JACCS のショッピングローンは国内向けのため、文言のある言語（日本語）だけ表示する。
     リンク先はテーマ側のリンクをそのまま移して使う。
     The JACCS loan is for customers in Japan, so the line only appears in
     languages that have the text (Japanese). The theme's own link is reused. */
  function buildLoan() {
    var loan = document.querySelector('.Product .nv-btn-row a:not([href*="contact"])');
    if (!loan || document.querySelector('.nv-loan')) { return; }
    if (!t.loanNote) { loan.classList.add('nv-loan-off'); return; }
    var facts = document.querySelector('.ProductMeta .nv-facts');
    var after = document.querySelector('.ProductMeta .nv-stock') || document.querySelector('.ProductMeta .nv-was') ||
      document.querySelector('.ProductMeta .ProductMeta__PriceList');
    if (!facts && !after) { return; }
    var line = make('div', 'nv-loan');
    line.appendChild(make('span', 'nv-loan__note', t.loanNote));
    loan.className = 'nv-loan__link';
    loan.textContent = t.loanCalc + ' ›';
    line.appendChild(loan);
    if (facts) { facts.parentNode.insertBefore(line, facts); }
    else { after.parentNode.insertBefore(line, after.nextSibling); }
  }

  /* ---------- 画像右上のランク / Rank badge on the image ---------- */
  function buildImageRank() {
    var gallery = document.querySelector('.Product__Gallery');
    var c = document.querySelector('.nv-facts__chip');
    if (!gallery || !c || gallery.querySelector('.nv-img-rank')) { return; }
    var b = make('div', 'nv-img-rank');
    b.style.setProperty('--nv-rank', c.style.getPropertyValue('--nv-rank'));
    b.setAttribute('aria-hidden', 'true');
    b.appendChild(make('b', '', c.textContent));
    b.appendChild(make('span', '', t.rank));
    gallery.appendChild(b);
    gallery.classList.add('nv-has-rank');
  }

  /* ---------- 商品コードのコピー / Copy the item code ---------- */
  function buildCopy() {
    var sku = document.querySelector('.ProductMeta .nv-sku');
    if (!sku || sku.querySelector('.nv-copy')) { return; }
    var value = (sku.textContent.split(/[：:]/).pop() || '').trim();
    if (!value) { return; }
    var btn = make('button', 'nv-copy');
    btn.type = 'button';
    btn.innerHTML = svg(ICON.copy, 14) + '<span></span>';
    btn.lastChild.textContent = t.copy;
    btn.addEventListener('click', function () {
      if (!navigator.clipboard || !navigator.clipboard.writeText) { return; }
      navigator.clipboard.writeText(value).then(function () {
        btn.lastChild.textContent = t.copied;
        setTimeout(function () { btn.lastChild.textContent = t.copy; }, 1600);
      }, function () {});
    });
    sku.appendChild(btn);
  }

  /* ============================================================
     ボタンまわり / Buttons
     ============================================================ */
  function buildButtons() {
    // 店舗ボタンにアイコン / Icon on the in-store button
    var store = document.querySelector('.Product .nv-btn--dark');
    if (store && !store.querySelector('svg')) { store.insertAdjacentHTML('afterbegin', svg(ICON.store, 18)); }

    // お支払方法にアイコン / Icon on the payment line
    var pay = document.querySelector('.Product .nv-pay');
    if (pay && !pay.querySelector('svg')) { pay.insertAdjacentHTML('afterbegin', svg(ICON.card, 17)); }

    // お気に入り：アプリのボタンは隠し、文字リンクから押す
    // Wishlist: hide the app button and press it from a text link
    var row = document.querySelector('.Product .nv-btn-row');
    var gw = document.querySelector('.ProductForm .gw-wl-add-to-wishlist-placeholder');
    if (!row || !gw || row.querySelector('.nv-fav')) { return; }
    var fav = make('button', 'nv-btn nv-btn--soft nv-fav');
    fav.type = 'button';
    fav.innerHTML = svg(ICON.heart, 17) + '<span></span><span class="nv-fav__n"></span>';
    fav.children[1].textContent = t.fav;
    row.insertBefore(fav, row.firstChild);

    function appButton() { return gw.shadowRoot && gw.shadowRoot.querySelector('button'); }
    function sync() {
      var b = appButton();
      if (!b) { return false; }
      gw.classList.add('nv-gw-hidden');
      row.classList.add('nv-has-fav');
      var n = b.getAttribute('data-gw-wishlist-items-count');
      fav.lastChild.textContent = n && n !== '0' ? '（' + n + '）' : '';
      fav.classList.toggle('is-on', b.getAttribute('data-in-wishlist') === 'true');
      clearAsideSoon();
      return true;
    }
    fav.addEventListener('click', function () {
      var b = appButton();
      if (b) { b.click(); }
    });
    // アプリの描画を待ち、状態の変化を追う / Wait for the app, then follow its state
    var tries = 0;
    (function wait() {
      if (sync()) {
        new MutationObserver(sync).observe(appButton(), { attributes: true });
        return;
      }
      if (++tries < 60) {
        setTimeout(wait, 250);
      } else {
        // アプリが出ない時は元のボタンに戻す / Fall back to the app's own button
        fav.parentNode.removeChild(fav);
      }
    })();
  }

  /* ---------- お支払方法：項目と「／」をまとめる / Keep each payment item with its separator ---------- */
  function groupPay() {
    var list = document.querySelector('.nv-pay__list');
    if (!list || list.getAttribute('data-nv-grouped') === '1') { return; }
    list.setAttribute('data-nv-grouped', '1');
    var kids = Array.prototype.slice.call(list.children);
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (k.classList.contains('nv-pay__sep')) { continue; }
      var g = make('span', 'nv-pay__item');
      list.insertBefore(g, k);
      g.appendChild(k);
      var next = kids[i + 1];
      if (next && next.classList.contains('nv-pay__sep')) { g.appendChild(next); }
    }
  }

  /* ---------- 固定カートボタン（スマホ） / Sticky add-to-cart (mobile) ---------- */
  function buildSticky() {
    var atc = document.querySelector('.ProductForm__AddToCart');
    if (!atc || atc.disabled || document.querySelector('.nv-sticky')) { return; }
    if (!('IntersectionObserver' in window)) { return; }
    var bar = make('div', 'nv-sticky');
    var info = make('div', 'nv-sticky__info');
    var price = make('span', 'nv-sticky__price');
    info.appendChild(price);
    var c = document.querySelector('.nv-facts__chip');
    if (c) { info.appendChild(c.cloneNode(true)); }
    var btn = make('button', 'nv-sticky__btn', txt(atc.querySelector('span') || atc));
    btn.type = 'button';
    btn.addEventListener('click', function () { atc.click(); });
    bar.appendChild(info);
    bar.appendChild(btn);
    document.body.appendChild(bar);
    var tabbar = document.querySelector('.nv-tabbar');
    function place() {
      var h = 0;
      if (tabbar && window.getComputedStyle(tabbar).position === 'fixed') { h = tabbar.offsetHeight; }
      bar.style.bottom = h + 'px';
    }
    place();
    window.addEventListener('resize', place);
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var on = !e.isIntersecting && e.boundingClientRect.top < 0 && !window.matchMedia(DESK).matches;
      if (on) {
        price.textContent = txt(document.querySelector('.ProductMeta .ProductMeta__Price'));
        place();
      }
      bar.classList.toggle('is-on', on);
    }).observe(atc);
  }

  /* ============================================================
     説明文の組み替え / Rebuild the description
     ============================================================ */
  function section(title, summary, open, card) {
    var s = make('section', 'nv-sec' + (card ? ' nv-sec--card' : '') + (open ? ' is-open' : ''));
    var head = make('button', 'nv-sec__head');
    head.type = 'button';
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
    head.appendChild(make('span', 'nv-sec__title', title));
    var sum = make('span', 'nv-sec__sum');
    if (summary) { sum.appendChild(typeof summary === 'string' ? document.createTextNode(summary) : summary); }
    head.appendChild(sum);
    head.insertAdjacentHTML('beforeend', svg(ICON.chevron, 18));
    head.addEventListener('click', function () {
      if (window.matchMedia(DESK).matches) { return; }
      var o = s.classList.toggle('is-open');
      head.setAttribute('aria-expanded', o ? 'true' : 'false');
    });
    var body = make('div', 'nv-sec__body');
    s.appendChild(head);
    s.appendChild(body);
    s.body = body;
    return s;
  }

  // 1行（ラベル｜値）。値の2行目（<br> 以降）は補足として小さく
  // One row (label | value). The part after <br> becomes a small note.
  function row(label, vl) {
    var r = make('div', 'nv-row');
    r.appendChild(make('span', 'nv-row__lb', label));
    var v = make('span', 'nv-row__vl');
    var parts = (vl.innerHTML || '').split(/<br\s*\/?>/i);
    var d = document.createElement('div');
    d.innerHTML = parts[0];
    v.textContent = txt(d);
    if (parts.length > 1) {
      d.innerHTML = parts.slice(1).join(' ');
      if (txt(d)) { v.appendChild(make('span', 'nv-row__sub', txt(d))); }
    }
    r.appendChild(v);
    return r;
  }
  function rowsOf(sec, skip) {
    var out = [];
    var rs = sec.querySelectorAll('.lx-row');
    for (var i = 0; i < rs.length; i++) {
      var lb = rs[i].querySelector('.lx-lb');
      var vl = rs[i].querySelector('.lx-vl');
      if (!lb || !vl) { continue; }
      if (skip && skip.indexOf(txt(lb)) !== -1) { continue; }
      out.push(row(txt(lb), vl));
    }
    return out;
  }
  function secTitle(sec) { return txt(sec.querySelector('.lx-sh')); }
  function sub(text) { return make('div', 'nv-subhead', text); }

  // バッグのサイズ図（日本語の「H約◯cm × W約◯cm × D約◯cm」のみ）
  // Bag size diagram, only for the Japanese "H × W × D" format
  function bagDiagram(sizeSec) {
    var data = productData();
    var type = data && data.product ? String(data.product.type || '') : '';
    if (code !== 'ja' || type.indexOf('バッグ') === -1) { return null; }
    var rs = sizeSec.querySelectorAll('.lx-row');
    var main = null, handle = null, i;
    for (i = 0; i < rs.length; i++) {
      var lb = txt(rs[i].querySelector('.lx-lb'));
      var vl = txt(rs[i].querySelector('.lx-vl'));
      if (lb === 'サイズ') { main = vl; }
      if (lb === 'ハンドル高さ') { handle = vl; }
    }
    var m = main && main.match(/H\s*約?\s*([\d.]+)\s*cm.*?W\s*約?\s*([\d.]+)\s*cm(?:.*?D\s*約?\s*([\d.]+)\s*cm)?/);
    if (!m) { return null; }
    var hm = handle && handle.match(/([\d.]+)\s*cm/);
    var box = make('div', 'nv-diagram');
    box.innerHTML =
      '<svg viewBox="0 0 350 220" role="img" aria-label="' + t.width + ' ' + m[2] + 'cm, ' + t.height + ' ' + m[1] + 'cm">' +
      (hm ? '<path d="M75 34.5H175M75 78H95" stroke="#C9C3B8" stroke-dasharray="3 3" fill="none"/>' +
            '<path d="M130 78C130 20 220 20 220 78" stroke="#1C1B1B" stroke-width="1.4" fill="none"/>' : '') +
      '<rect x="95" y="78" width="160" height="104" rx="16" fill="#FAF8F4" stroke="#1C1B1B" stroke-width="1.4"/>' +
      '<path d="M95 200H255M95 194V206M255 194V206M275 78V182M269 78H281M269 182H281" stroke="#8A6E44" stroke-width="1.2" fill="none"/>' +
      (hm ? '<path d="M75 34.5V78M69 34.5H81M69 78H81" stroke="#8A6E44" stroke-width="1.2" fill="none"/>' : '') +
      '<g font-size="12.5" fill="#1C1B1B">' +
      '<text x="175" y="217" text-anchor="middle">' + t.width + ' 約' + m[2] + 'cm</text>' +
      '<text x="289" y="126">' + t.height + '</text><text x="289" y="143">約' + m[1] + 'cm</text>' +
      (hm ? '<text x="62" y="52" text-anchor="end">' + t.handle + '</text><text x="62" y="69" text-anchor="end">約' + hm[1] + 'cm</text>' : '') +
      '</g></svg>';
    return { node: box, depth: m[3] || null, skip: ['サイズ', 'ハンドル高さ'] };
  }

  function buildDetails(root) {
    var nav = root.querySelector('.nv-tabs__nav');
    var panels = root.querySelector('.nv-tabs__panels');
    if (!nav || !panels || root.querySelector('.nv-dt')) { return; }
    var P = function (k) { return panels.querySelector('[data-nv-panel="' + k + '"]'); };
    var i, j, secs;

    var dt = make('div', 'nv-dt');
    var cols = make('div', 'nv-dt__cols');
    var cards = make('div', 'nv-dt__cards');
    dt.appendChild(cols);
    dt.appendChild(cards);

    // 1. 商品情報 / Product information
    var info = section(t.info, '', true);
    secs = P('detail') ? P('detail').querySelectorAll('.lx-sec') : [];
    for (i = 0; i < secs.length; i++) {
      var rs = rowsOf(secs[i]);
      if (i > 0 && (rs.length || txt(secs[i]))) { info.body.appendChild(sub(secTitle(secs[i]))); }
      if (rs.length) {
        for (j = 0; j < rs.length; j++) { info.body.appendChild(rs[j]); }
      } else if (i > 0) {
        var para = secs[i].cloneNode(true);
        var sh = para.querySelector('.lx-sh');
        if (sh) { sh.parentNode.removeChild(sh); }
        para.className = 'nv-text';
        info.body.appendChild(para);
      }
    }
    if (info.body.children.length) { cols.appendChild(info); }

    // 2. サイズ（＋仕様） / Size (+ specs)
    var size = section(t.size, '', true);
    secs = P('size') ? P('size').querySelectorAll('.lx-sec') : [];
    var firstSize = true;
    for (i = 0; i < secs.length; i++) {
      if (secs[i].querySelector('.lx-parts')) { continue; }
      if (firstSize) {
        firstSize = false;
        var dia = bagDiagram(secs[i]);
        if (dia) {
          size.body.appendChild(dia.node);
          if (dia.depth) {
            var dv = make('span');
            dv.textContent = '約' + dia.depth + 'cm';
            size.body.appendChild(row(t.depth, dv));
          }
          var rest = rowsOf(secs[i], dia.skip);
          for (j = 0; j < rest.length; j++) { size.body.appendChild(rest[j]); }
        } else {
          var rs2 = rowsOf(secs[i]);
          for (j = 0; j < rs2.length; j++) { size.body.appendChild(rs2[j]); }
        }
      } else {
        size.body.appendChild(sub(secTitle(secs[i])));
        var rs3 = rowsOf(secs[i]);
        for (j = 0; j < rs3.length; j++) { size.body.appendChild(rs3[j]); }
      }
    }
    if (size.body.children.length) { cols.appendChild(size); }

    // 3. コンディション / Condition
    // custom.js が概要欄に表を複製しているため、コンディション欄だけを見る
    // custom.js copies the table into its summary, so read the condition panel only
    var cp = P('condition') || root;
    var trs = cp.querySelectorAll('.lx-rnk tr');
    var activeGrade = '';
    if (trs.length) {
      var ranks = make('div', 'nv-grades');
      for (i = 0; i < trs.length; i++) {
        var tds = trs[i].querySelectorAll('td');
        if (tds.length < 2) { continue; }
        var on = trs[i].classList.contains('active');
        var r = make('div', 'nv-grade' + (on ? ' is-on' : ''));
        r.appendChild(chip(txt(tds[0])));
        r.appendChild(make('span', 'nv-grade__desc', txt(tds[1])));
        if (on) {
          r.appendChild(make('span', 'nv-grade__tag', t.thisItem));
          activeGrade = txt(tds[0]);
        }
        ranks.appendChild(r);
      }
      var cond = section(t.condition, activeGrade ? chip(activeGrade) : '', false);
      cond.body.appendChild(ranks);

      // ベルトランク（腕時計） / Belt grade (watches)
      var bg = cp.querySelector('.lx-belt-single-grade');
      if (bg) {
        cond.body.appendChild(sub(txt(cp.querySelector('.lx-belt-label'))));
        var br = make('div', 'nv-grade is-on');
        br.appendChild(chip(txt(bg)));
        br.appendChild(make('span', 'nv-grade__desc', txt(cp.querySelector('.lx-belt-single-desc'))));
        cond.body.appendChild(br);
      }

      var cr = cp.querySelectorAll('.lx-cond-box .lx-row');
      if (cr.length) {
        cond.body.appendChild(sub(t.state));
        var boxes = make('div', 'nv-boxes');
        for (i = 0; i < cr.length; i++) {
          var b = make('div', 'nv-box');
          b.appendChild(make('span', 'nv-box__lb', txt(cr[i].querySelector('.lx-lb'))));
          b.appendChild(make('span', 'nv-box__vl', txt(cr[i].querySelector('.lx-vl'))));
          boxes.appendChild(b);
        }
        cond.body.appendChild(boxes);
      }
      cols.appendChild(cond);
    }

    // 4. 付属品 / Accessories
    var acc = accText(root);
    if (acc !== null) {
      var items = acc ? acc.split(/[、,，]\s*/) : [];
      var accSec = section(t.acc, items.length ? fill(t.accCount, items.length) : t.none, false, true);
      // 点数は PC の見出しだけに付ける / The count is added to the desktop title only
      if (items.length) {
        accSec.querySelector('.nv-sec__title').appendChild(make('span', 'nv-desk-only', fill(t.accN, items.length)));
      }
      if (items.length) {
        var ul = make('ul', 'nv-check');
        for (i = 0; i < items.length; i++) {
          var li = make('li');
          li.innerHTML = svg(ICON.check, 16);
          li.appendChild(document.createTextNode(items[i]));
          ul.appendChild(li);
        }
        accSec.body.appendChild(ul);
      } else {
        accSec.body.appendChild(make('p', 'nv-text', t.none));
      }
      cards.appendChild(accSec);
    }

    // 保証（対象商品のみ）と検品の注記 / Warranty (covered items only) and the inspection note
    var wp = P('warranty');
    var covered = wp && wp.querySelector('.nv-wr__row--on');
    var insp = wp && wp.querySelector('[data-nv-t="insp"]');

    // 5. ご購入前の注意事項 / Before you buy
    var notes = root.querySelector('.lx-notes');
    if (notes) {
      var n = section(t.notes, '', false, true);
      var np = make('p', 'nv-text');
      var h = notes.innerHTML;
      if (code === 'ja' && t.cod) {
        var at = h.search(/※\s*The payment method/i);
        if (at !== -1) { h = h.slice(0, at) + t.cod; }
      }
      np.innerHTML = h;
      n.body.appendChild(np);
      if (insp && !covered) { n.body.appendChild(make('p', 'nv-text nv-text--note', txt(insp))); }
      cards.appendChild(n);
    }

    // 6. お支払い・配送・返品 / Payment, shipping and returns
    var pay = document.querySelector('.Product .nv-pay__list');
    var ps = section(t.payShip, '', false, true);
    if (pay) {
      var kv = make('div', 'nv-kv');
      kv.appendChild(make('div', 'nv-kv__k', t.payMethods));
      var pv = make('div', 'nv-kv__v');
      pv.innerHTML = pay.innerHTML;
      kv.appendChild(pv);
      ps.body.appendChild(kv);
    }
    if (t.shipText) {
      var kv2 = make('div', 'nv-kv');
      kv2.appendChild(make('div', 'nv-kv__k', t.ship));
      kv2.appendChild(make('div', 'nv-kv__v', t.shipText));
      ps.body.appendChild(kv2);
    }
    var ret = make('a', 'nv-link', t.returns);
    ret.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'policies/refund-policy';
    ps.body.appendChild(ret);
    cards.appendChild(ps);

    // 7. 保証について（腕時計など対象商品のみ） / Warranty, covered items only
    if (covered) {
      var onDd = wp.querySelector('.nv-wr__row--on dd');
      var w = section(t.warranty, txt(onDd), false, true);
      var wr = wp.querySelectorAll('.nv-wr__row');
      for (i = 0; i < wr.length; i++) {
        var x = make('div', 'nv-wrow' + (wr[i].classList.contains('nv-wr__row--on') ? ' is-on' : ''));
        x.appendChild(make('span', '', txt(wr[i].querySelector('dt'))));
        x.appendChild(make('span', '', txt(wr[i].querySelector('dd'))));
        w.body.appendChild(x);
      }
      if (insp) { w.body.appendChild(make('p', 'nv-text nv-text--note', txt(insp))); }
      cards.appendChild(w);
    }

    root.classList.add('nv-pdp-tabs');
    nav.parentNode.insertBefore(dt, nav);
  }

  /* ---------- お問い合わせ欄にフォームへのボタン / Contact button in the inquiry box ---------- */
  function buildInquiry() {
    var inq = document.querySelector('.lx-inq');
    var contact = document.querySelector('.Product .nv-btn-row a[href*="contact"]');
    if (!inq || !contact || inq.querySelector('.nv-inq-btn')) { return; }
    var a = make('a', 'nv-inq-btn');
    a.href = contact.getAttribute('href');
    a.innerHTML = svg(ICON.mail, 17) + '<span></span>';
    a.lastChild.textContent = t.inquiry;
    inq.appendChild(a);
  }

  /* ---------- PC：右カラムを説明文に重ねない / Keep the right column clear (desktop) ---------- */
  function clearAside() {
    var aside = document.querySelector('.Product__Aside');
    var info = document.querySelector('.Product__Info');
    var wrap = info && info.closest('.Product__InfoWrapper');
    if (!aside || !info || !wrap) { return; }
    aside.style.marginTop = '';
    if (!window.matchMedia(DESK).matches) { return; }
    function gap() {
      return aside.getBoundingClientRect().top - (wrap.getBoundingClientRect().top + info.offsetHeight + 40);
    }
    // 上の要素の余白と相殺されることがあるので2回で合わせる
    // Margins can collapse with the element above, so settle it in two passes
    var g = gap();
    if (g < 0) {
      var m = (parseFloat(window.getComputedStyle(aside).marginTop) || 0) - g;
      aside.style.marginTop = m + 'px';
      g = gap();
      if (g < 0) { aside.style.marginTop = (m - g) + 'px'; }
    }
    wrap.style.maxHeight = Math.max(0, aside.offsetTop - 40) + 'px';
  }
  var clearTimer = null;
  function clearAsideSoon() {
    if (clearTimer) { clearTimeout(clearTimer); }
    clearTimer = setTimeout(clearAside, 150);
  }

  /* ---------- 起動 / Start ---------- */
  function run() {
    var root = document.querySelector('[data-nv-tabs]');
    buildPrice();
    moveStock();
    waitCountdown();
    buildCopy();
    groupPay();
    if (root) {
      buildFacts(root);
      buildDetails(root);
    }
    buildLoan();
    buildImageRank();
    buildButtons();
    buildInquiry();
    buildSticky();

    clearAside();
    var info = document.querySelector('.Product__Info');
    if (info && 'ResizeObserver' in window) { new ResizeObserver(clearAsideSoon).observe(info); }
    window.addEventListener('load', clearAsideSoon);
    window.addEventListener('resize', clearAsideSoon);
    setTimeout(clearAside, 1000);
    setTimeout(clearAside, 2100);
    setTimeout(clearAside, 4000);
  }

  // custom.js のタブ構築を待つ（最大約5秒） / Wait for custom.js (about 5 s max)
  function waitAndRun(tries) {
    var root = document.querySelector('[data-nv-tabs]');
    if (!root || root.getAttribute('data-nv-tabs-built') === '1' || tries > 50) {
      run();
      return;
    }
    setTimeout(function () { waitAndRun(tries + 1); }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { waitAndRun(0); });
  } else {
    waitAndRun(0);
  }
})();